export const serviceProviderUnitCalendarAreaPathName = 'udforerkalender';
